import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIsMobile, useWindowSize } from 'utils/hooks';
import Dialog from 'components/Ui/Dialog';
import { Document, Page } from 'react-pdf';
import styles from './styles.scss';

const InvoiceDialog = ({ open, setStatus, file }) => {
  const isMobile = useIsMobile();
  const size = useWindowSize();
  const maxWidth = isMobile ? size.width : 560;

  const [numOfPages, setNumOfPages] = useState(null);

  const options = {
    cMapUrl: 'cmaps/',
    cMapPacked: true,
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumOfPages(numPages);
  };

  return (
    <Dialog
      size="large"
      fullScreen={isMobile}
      isAutoClose={false}
      isCloseIcon
      open={open}
      onClose={setStatus}
      overflowContent
    >
      <div className={styles.container}>
        <div
          className={!isMobile ? styles.subContainer : styles.mobileContainer}
        >
          <Document
            file={file}
            onLoadSuccess={onDocumentLoadSuccess}
            options={options}
            className={styles.document}
          >
            {Array.from(new Array(numOfPages), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                renderMode="svg"
                width={Math.min(size.width, maxWidth)}
              />
            ))}
          </Document>
        </div>
      </div>
    </Dialog>
  );
};

InvoiceDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setStatus: PropTypes.func.isRequired,
  file: PropTypes.object,
};

export default InvoiceDialog;
